<div class="automation-hub-container">
  <app-monaco-code-editor 
    [code]="code || ''" 
    [editorOptions]="editorOptions || {}"
    [editorHeight]="editorHeight || 400"
    (codeChange)="onCodeChange($event)">
  </app-monaco-code-editor>
</div>
